module.exports = __webpack_public_path__ + "img/20200514_142941.61ea6115.jpg";